<template>
<div class="history-content">
	<div class="van-nav-bar van-hairline--bottom custom-nav-bar">
		<div class="van-nav-bar__content">
			<div class="van-nav-bar__left van-haptics-feedback" @click="back()">
				<i class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
			</div>
			<div class="van-nav-bar__title van-ellipsis">
				{{$t('game.workRecord')}}
			</div>
			<div class="van-nav-bar__right van-haptics-feedback"  @click="showRight ? showRight = false : showRight = true">
				<i class="van-badge__wrapper van-icon van-icon-apps-o"
				style="font-size: 24px;"></i>
			</div>
		</div>
	</div>
	<van-tabs color="#667eea" title-active-color="#667eea" :before-change="beforeChange" title-inactive-color="#667eea" animated>
	  <van-tab :title="v.name" class="det" v-for="(v,key) in navList" :key="key">
		  <div class="history">
			  <van-pull-refresh v-model="isLoading" class="fixedStyle"  @refresh="onRefresh">
			    <van-list
			        v-model="loading"
			        :finished="finished"
			        :immediate-check="false"
			        :finished-text="$t('common.nomore')"
			        >
			  	  <div class="list-container">
					  <van-cell-group class="custom-cell-group">
			  	    <van-cell v-for="(item,i) in list" :key="i" class="custom-cell" @click="toDetail(item)" >
			  			<template #title>
			  				<div class="cell-content">
								<div class="icon-box">
									<span class="icon">$</span>
								</div>
								<div class="info">
									<span class="game-name">{{item.name}}</span>
									<span class="game-types">
										{{$t('orderContentLabel')}}
										<span v-for="(datai,ss) in item.data" :key="ss">{{$t('game.'+datai.type)}} </span>
									</span>
								</div>
			  				</div>
			  			</template>
						<template #default>
							<div class="right-content">
								<span class="period-info">
									{{$t('game.day')}}{{item.expect}}{{$t('game.period')}}
								</span>
								<span class="amount">{{item.money}}</span>
							</div>
						</template>
			  		</van-cell>
			  	  </van-cell-group>
				  </div>
			    </van-list>
			    <van-empty :description="$t('common.nodata')" v-if="list.length === 0"/>
			  </van-pull-refresh>
		  </div>
	  </van-tab>
	</van-tabs>
	<van-popup v-model="showRight" position="right" class="his" :style="{ width: '80%' ,height: '100%'}" >
		<p>{{$t('game.allWork')}}</p>
		<ul>
			<li @click="changeLottery(v.id)" v-for="(v,key) in game_type_list" :key="key" :class="v.id==lottery_id?'active':''">
				{{v.name}}
			</li>
		</ul>
		<div class="btn">
			<p @click="lottery_id='all'">{{$t('game.reset')}}</p>
			<p @click="showRight=false">{{$t('game.confirm')}}</p>
		</div>
	</van-popup>
</div>
</template>

<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
		showRight:false,
		lottery_id:'all',
		game_type_list: [{},{},{},{}],
		status:0,
		page:1,
		isLoading: false,
		count:0,
		limit:10,
		loading: false,
		finished: false,
		refreshing: false,
		tableList:[],
		list:[],
		navList:[{name:this.$t('all'),value:0},{name:this.$t('bonusPointsLabel'),value:1},{name:this.$t('waitingResultLabel'),value:2},{name:this.$t('missionMoneyDetails'),value:3}],
    };
  },
  mounted () {
    this.getUserGameList()
    window.addEventListener("scroll", this.scrollTops, true);
  },
  
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollTops);
  },
  methods: {
    back(){
      this.$router.push({path:'Mine'})
    },
	getGameItem(){
	  this.$http({
	    method: 'get',
	    url: 'lottery_hot'
	  }).then(res=>{
	    this.game_type_list = res.data
	  })
	},
	toDetail(item){
	  this.$router.push({path:'/GameDetail?expect='+item.expect+"&lid="+item.lottery_id+"&name="+item.name+"&money="+item.money+"&touzhu="+item.touzhu+"&time="+item.create_time+"&status="+item.status})  
	},
	beforeChange(index) {
	  this.status = index;
	  this.getUserGameList()
	  return true;
	},
	longPress() {
	  document.querySelector('.fixedStyle').scrollTop = 0
	},
	scrollTops(){
	  this.scrollTop1 = document.querySelector('.fixedStyle').scrollTop
	},
    onRefresh(){
      setTimeout(() => {
        this.finished = false;
        this.loading = true;
        this.onLoad();
        this.isLoading = false;
        Toast(this.$t('common.refresh'));
      }, 500);
    },
	changeLottery(id){
		this.lottery_id = id;
		this.getUserGameList();
	},
    getUserGameList(){
      this.$http({
        method: 'get',
		data:{page: this.page,limit: this.limit,status:this.status,lottery_id:this.lottery_id},
        url: 'user_get_game_list'
      }).then(res=>{
        if(res.code === 200){
			console.log(res.data)
          this.list = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
	onLoad() {
	  this.getUserGameList()
	  let timer = setTimeout(() => {
	    if (this.refreshing) {
	      this.tableList = [];
	      this.refreshing = false;
	    }
	    this.loading = false;
	    if (this.tableList.length === this.count) {
	      this.finished = true;
	    }
	    this.finished && clearTimeout(timer);
	  }, 500);
	},
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserGameList();
	  this.getGameItem();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

:export {
    gbcolor: linear-gradient(135deg, #3498db, #8e44ad)
}

.history-content {
    width: 100%;
    min-height: 100vh;
    background: white;
}

/* 顶部导航栏样式 - 填充渐变色 */
.custom-nav-bar {
    height: 3.5rem;
    line-height: 3.5rem;
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
    position: relative;
    z-index: 10;
}

.custom-nav-bar::after {
    display: none;
}

.van-nav-bar__title {
    max-width: 60%;
    margin: 0 auto;
    color: white !important;
    font-weight: 600;
    font-size: 1.1rem;
}

.van-nav-bar__left,
.van-nav-bar__right {
    padding: 0 15px;
}

.van-nav-bar__arrow,
.van-nav-bar__right .van-icon {
    color: white !important;
    font-size: 1.2rem;
}

/* 标签页样式 */
.van-tabs {
    background: white;
}

::v-deep .van-tabs__wrap {
    background: white;
    border-bottom: 1px solid #f0f0f0;
}

::v-deep .van-tab {
    font-size: 0.9rem;
}

/* 内容区域 */
.history {
    background: white;
}

.fixedStyle {
    background: white;
    min-height: calc(100vh - 8rem);
}

.list-container {
    padding: 1rem;
}

/* 自定义单元格组 */
.custom-cell-group {
    background: transparent;
    border: none;
}

.custom-cell-group::after,
.custom-cell-group::before {
    display: none;
}

/* 每个栏目带边框 */
.custom-cell {
    margin-bottom: 0.8rem;
    border: 1.5px solid #e8e8e8;
    border-radius: 12px;
    padding: 1rem;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    cursor: pointer;
}

.custom-cell:active {
    background-color: #f8f9ff;
    border-color: #667eea;
    transform: translateY(1px);
}

.custom-cell::after {
    display: none;
}

/* 单元格内容布局 */
.cell-content {
    display: flex;
    align-items: center;
    gap: 0.8rem;
}

.icon-box {
    width: 3rem;
    height: 3rem;
    background: linear-gradient(135deg, #3498db, #8e44ad);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
}

.icon {
    color: white;
    font-size: 1.2rem;
    font-weight: bold;
}

.info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
}

.game-name {
    font-size: 1rem;
    font-weight: 600;
    color: #333;
}

.game-types {
    font-size: 0.85rem;
    color: #666;
}

/* 右侧内容 */
.right-content {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.3rem;
}

.period-info {
    font-size: 0.8rem;
    color: #b2a8cd;
}

.amount {
    font-size: 1rem;
    font-weight: 600;
    color: #36c989;
}

/* 侧边栏样式 */
.his {
    width: 80%;
    height: 100%;
    padding: 5%;
    background: white;
}

.his p {
    text-align: left;
    font-size: 1rem;
    color: #4c368c;
    font-weight: 600;
    margin-bottom: 1rem;
}

.his ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    padding-top: 1rem;
}

.his ul li {
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #667eea;
    border: 1.5px solid #667eea;
    border-radius: 8px;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
    padding: 0.5rem 0;
    font-size: 0.9rem;
    transition: all 0.3s ease;
}

.his ul li.active {
    color: white;
    border: none;
    background: linear-gradient(135deg, #3498db, #8e44ad);
}

.his .btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    padding: 5%;
}

.his .btn p {
    color: #667eea;
    border: 1.5px solid #667eea;
    border-radius: 25px;
    padding: 0.5rem 1.5rem;
    font-size: 0.9rem;
    transition: all 0.3s ease;
}

.his .btn p:last-child {
    color: white;
    border: none;
    background: #667eea;
}

.his .btn p:active {
    transform: scale(0.95);
}

/* 空状态样式 */
.van-empty {
    padding: 3rem 1rem;
}

::v-deep .van-empty__description {
    color: #969799;
    font-size: 0.9rem;
}

/* 动画效果 */
@keyframes fadeInUp {
    from { 
        opacity: 0; 
        transform: translateY(15px); 
    }
    to { 
        opacity: 1; 
        transform: translateY(0); 
    }
}

.custom-cell {
    animation: fadeInUp 0.4s ease forwards;
}

.custom-cell:nth-child(odd) {
    animation-delay: 0.1s;
}

.custom-cell:nth-child(even) {
    animation-delay: 0.2s;
}

/* 响应式调整 */
@media (max-width: 320px) {
    .list-container {
        padding: 0.8rem;
    }
    
    .custom-cell {
        padding: 0.8rem;
        margin-bottom: 0.6rem;
    }
    
    .icon-box {
        width: 2.5rem;
        height: 2.5rem;
    }
    
    .icon {
        font-size: 1rem;
    }
    
    .game-name {
        font-size: 0.95rem;
    }
    
    .game-types {
        font-size: 0.8rem;
    }
}
</style>
